import Backbone from 'backbone';
import apiUrlMethodsDescriptor from '../apiUrlMethods';

Object.defineProperties(
	Backbone.Model.prototype,
	{
		...apiUrlMethodsDescriptor,
		isNew: {
			value: function() {
				return true;
			},
			writable: true,
			configurable: true
		}
	}
);